import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trim'
})
export class TrimPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let res = value.replace(/\s/g, "");
    // console.log(value, '+', res);
    return res;
  }

}
